enum InspectionStatus { //ToDo use UUIDs for statuses
    PLANNED = 'FC97744B-89CF-4EE9-A21F-C3EC65E5533C',
    STARTED = '0723E131-D958-4623-8F3A-85055A0A7413',
    FINISHED = '8045CDC4-7824-4C62-AF88-99AFCA20BE85',
    CLOSED = 'A2ED14F3-0B1C-4911-BA88-B8574BF2A37C',
    CREATED = 'D34AECFF-4A2B-4571-9CD3-C5FA0F0FC807',
    PAUSED = 'D64D9BC1-9C57-4E6E-A62E-CD4F2B67B9C7',
} export default InspectionStatus;